import React, { createContext, useContext, useMemo } from 'react';

import useCustomPacingData from './hooks/useCustomPacingData';
import useCustomPacingStepper from './hooks/useCustomPacingStepper';
import type { CustomPacingScheduleProps, CustomPacingScheduleType } from './types';

const CustomPacingScheduleContext = createContext({} as CustomPacingScheduleType);

export const useCustomPacingScheduleContext = (): CustomPacingScheduleType => useContext(CustomPacingScheduleContext);

const CustomPacingScheduleProvider = ({ children, onClose }: CustomPacingScheduleProps): React.JSX.Element => {
  const { step, goToStep, initiateFlow, goToPrevStep } = useCustomPacingStepper();
  const { savedScheduleResult, setSavedScheduleResult } = useCustomPacingData();

  const value = useMemo(() => {
    return {
      step,
      goToStep,
      initiateFlow,
      goToPrevStep,
      onClose,
      savedScheduleResult,
      setSavedScheduleResult,
    };
  }, [step, goToStep, initiateFlow, goToPrevStep, onClose, savedScheduleResult, setSavedScheduleResult]);

  return <CustomPacingScheduleContext.Provider value={value}>{children}</CustomPacingScheduleContext.Provider>;
};

export default CustomPacingScheduleProvider;
